import styled from 'styled-components';

export const Truck = styled.svg`
    width: 45px;
    height: 45px;
`;
